module.exports = /*#__PURE__*/JSON.parse('{"version":"2026-07-08"}')